import { ISSUE_TYPE } from '../screen/GenerationPanel/Generationpanel.types';
import { ISSUE_PUBLISH_COUNT_THRESHOLD } from '../common/Constants';

const Strings = {
  WELCOME: 'ship faster with AI generated backlogs',
  WELCOME_SUBTITLE: 'Ask for the backlog you need, then tailor it in minutes directly in Jira Cloud.',
  STEP_1_TITLE: 'Select what you would like to generate',
  STEP_1_DESCRIPTION:
    'Choose between epics, user stories or both depending on your project requirements',
  STEP_2_TITLE: 'Use AI prompt to generate epics and user stories',
  STEP_2_DESCRIPTION: 'Chat with storygenie by entering prompts, and let the tech work its magic',
  STEP_3_TITLE: 'Review and make changes ',
  STEP_3_DESCRIPTION:
    'Analyze the epics and user stories generated. Fine-tune them to perfection before publishing.',
  STEP_4_TITLE: 'Publish your changes to Jira',
  STEP_4_DESCRIPTION:
    'Once you are happy with the changes, publish them to Jira and return to your project',
  DISCLAIMER_TEXT:
    "Storygenie creates the structure while you verify and apply the context",
  LEARN_MORE: 'Learn more',
  TIPS_AND_TRICKS: 'Tips & Tricks',
  CLICK_HERE: 'click here',
  GREETING_TEXT: 'Hey there!',
  MESSAGE:
    'Looks like your screen’s a bit small for all the cool stuff our Jira app can do. For the best experience, jump on a device with a larger resolution.',
  SUBMESSAGE: 'Trust us, it’s worth it!',
  GREETS: 'Cheers,',
  USERNAME: 'S. Genie',
  TITLE: 'Story Genie',
  GENERATE_LOADER_MESSAGE: 'Assembling your story pieces... Hang tight!',
  PUBLISH_LOADER_MESSAGE: 'Publishing your issues to Jira... Just a sec!',
  PUBLISH_LOADER_TITLE: 'Sending your stories to Jira',
  PUBLISH_LOADER_SUBTITLE: 'StoryGenie is weaving your ideas into action! ✨',
  PUBLISH_SUCCESS_TITLE: 'Published Successfully  🎉',
  PUBLISH_SUCCESS_SUBTITLE: 'Your work items have shipped to Jira',
  ENHANCE_LOADER_MESSAGE: 'Enhancing your prompt... Hang tight!',
  SELECT_EPIC: 'Select Epic',
  DRAFT: 'NEW',
  SEARCH: 'Search',
  STORIES_GENERATED: 'User Stories',
  TASKS_GENERATED: 'Tasks',
  RESULT_PANEL_TITLE: 'Generated Issues',
  SUMMARY: 'summary',
  DESCRIPTION: 'description',
  EPIC: 'Epic',
  ACTION: 'Action',
  EPIC_RELOAD_SUCCESS: 'Successfully loaded epics from Jira!',
  EPIC_RELOAD_ERROR: 'Error loading epics from Jira. Please try refresh again.',
  PUBLISH_SUCCESS_TOAST_MESSAGE:
    'Successfully published issues to Jira! Please head to board to see them.',
  PUBLISH_BUTTON: 'Publish to Jira',
  CLEAR_ALL_BUTTON: 'Clear All',
  STORY_EDIT_MODAL: {
    TITLE: 'User Story Edit',
    SUMMARY_FIELD_TITLE: 'Summary',
    DESCRIPTION_FIELD_TITLE: 'Description',
    ASSIGN_EPIC_FIELD_TITLE: 'Parent Epic',
    SAVE_BUTTON: 'Save Changes',
    CANCEL_BUTTON: 'Cancel'
  },
  TASK_EDIT_MODAL: {
    TITLE: 'Task Edit',
    DESCRIPTION_PLACEHOLDER: 'Enter task description...'
  },
  EPIC_EDIT_MODAL: {
    TITLE: 'Epic Edit',
    SUMMARY_FIELD_TITLE: 'Summary',
    DESCRIPTION_FIELD_TITLE: 'Description',
    SAVE_BUTTON: 'Save Changes',
    CANCEL_BUTTON: 'Cancel'
  },
  EPIC_DELETE_MODAL: {
    TITLE: 'Remove epic',
    WARNING:
      'This action cannot be undone. Please select from one of the following options.',
    REMOVE_EPIC_BUTTON: 'Remove epic',
    REMOVE_EPIC_AND_CHILDREN_BUTTON: 'Remove epic & children'
  },
  STORY_DELETE_MODAL: {
    TITLE: 'Remove story',
    WARNING:
      'This action cannot be undone. Please select from one of the following options.',
    REMOVE_STORY_BUTTON: 'Remove story'
  },
  GENERATION_PANEL: {
    ISSUE_TYPE: 'What would you like to generate?',
    ISSUE_TYPE_OPTIONS: {
      [ISSUE_TYPE.EpicsAndStories]: 'Epics & stories',
      [ISSUE_TYPE.MultipleEpics]: 'Multiple epics',
      [ISSUE_TYPE.SingleEpic]: 'Single epic',
      [ISSUE_TYPE.SingleEpicMultiStories]: 'Single Epic & stories',
      [ISSUE_TYPE.MultipleStories]: 'Multiple stories',
      [ISSUE_TYPE.SingleStory]: 'Single story',
      [ISSUE_TYPE.EpicsAndTasks]: 'Epics & tasks',
      [ISSUE_TYPE.SingleEpicMultiTasks]: 'Single Epic & tasks',
      [ISSUE_TYPE.MultipleTasks]: 'Multiple tasks',
      [ISSUE_TYPE.SingleTask]: 'Single task',
      [ISSUE_TYPE.StoriesAndTasks]: 'Stories & tasks',
      [ISSUE_TYPE.SingleStoryMultiTasks]: 'Single Story & tasks'
    },
    ISSUE_TYPE_DESCRIPTIONS: {
      [ISSUE_TYPE.EpicsAndStories]: 'Generate a full project',
      [ISSUE_TYPE.MultipleEpics]: 'Create several epics at once',
      [ISSUE_TYPE.SingleEpic]: 'Generate one detailed epic',
      [ISSUE_TYPE.SingleEpicMultiStories]: 'One epic with related stories',
      [ISSUE_TYPE.MultipleStories]: 'Generate multiple stories',
      [ISSUE_TYPE.SingleStory]: 'Create one focused story',
      [ISSUE_TYPE.EpicsAndTasks]: 'Generate epics with tasks',
      [ISSUE_TYPE.SingleEpicMultiTasks]: 'One epic with related tasks',
      [ISSUE_TYPE.MultipleTasks]: 'Generate multiple tasks',
      [ISSUE_TYPE.SingleTask]: 'Create one focused task',
      [ISSUE_TYPE.StoriesAndTasks]: 'Generate stories with tasks',
      [ISSUE_TYPE.SingleStoryMultiTasks]: 'One story with related tasks'
    },
    ISSUE_TYPE_COLORS: {
      [ISSUE_TYPE.EpicsAndStories]: '#6366f1',
      [ISSUE_TYPE.MultipleEpics]: '#8b5cf6',
      [ISSUE_TYPE.SingleEpic]: '#a855f7',
      [ISSUE_TYPE.SingleEpicMultiStories]: '#d946ef',
      [ISSUE_TYPE.MultipleStories]: '#0ea5e9',
      [ISSUE_TYPE.SingleStory]: '#14b8a6',
      [ISSUE_TYPE.EpicsAndTasks]: '#6d28d9',
      [ISSUE_TYPE.SingleEpicMultiTasks]: '#7c3aed',
      [ISSUE_TYPE.MultipleTasks]: '#2563eb',
      [ISSUE_TYPE.SingleTask]: '#1d4ed8',
      [ISSUE_TYPE.StoriesAndTasks]: '#0f766e',
      [ISSUE_TYPE.SingleStoryMultiTasks]: '#0d9488'
    },
    ISSUE_TYPE_GROUPS: {
      EPICS: 'Epics',
      EPICS_AND_CHILDREN: 'Epics & Child Work Items',
      STORIES: 'Stories',
      TASKS: 'Tasks'
    },
    AI_PROMPT_HISTORY_TITLE: 'AI Prompt History',
    DEFAULT_HISTORY_PROMPT: 'Try one of our sample prompts below to get started!',
    PROMPT: 'Prompt',
    AI_PROMPT_INPUT_LABEL: 'New Prompt',
    AI_PROMPT_PLACEHOLDER: 'Start typing your idea here...',
    GENERATE: 'Generate',
    OPTIMISE: 'Optimise',
    RAPID_RESPONSE_AI: 'Rapid Response AI (Chat GPT-3.5)',
    COMPREHENSIVE_AI: 'Comprehensive AI (Chat GPT-4)',
    ENHANCE_BUTTON_LABEL: 'Click to enhance'
  },
  CLEAR_STORIES: {
    TITLE: 'Clear all generated issues?',
    DESCRIPTION:
      'This will remove all the issues generated and you will not be able to undo it once cleared.',
    CONFIRMATION: 'Are you sure you want to continue?',
    DENY_BUTTON_TEXT: 'No, Keep the issues',
    CONFIRM_BUTTON_TEXT: 'Yes, Clear All'
  },
  BULK_ACTIONS: {
    ACTIONS: 'Actions',
    ASSIGN_LABEL: 'Assign to Epics',
    ASSIGN_MODAL_TITLE: 'Assign user stories to Epics',
    ASSIGN_MODAL_DESCRIPTION: 'This will assign the selected user stories under selected Epic',
    ASSIGN_MODAL_BUTTON_LABEL: 'Assign',
    CANCEL_BUTTON: 'Cancel',
    DELETE_MODAL_TITLE: 'Delete selected items',
    DELETE_MODAL_DESCRIPTION:
      'This action will delete the selected items and will not be reversed. Are you sure you want to delete?',
    DELETE_BUTTON: 'Delete'
  },
  PUBLISH_TO_JIRA: {
    TITLE: 'Publish to Jira?',
    DESCRIPTION: 'Pack your bags! Your work items are shipping to Jira.',
    DENY_BTN_TEXT: 'Cancel',
    CONFIRM_BTN_TEXT: 'Publish'
  },
  DELETE: 'Delete',
  EDIT: 'Edit',
  NONE: 'None',
  EPICS: 'Epics',
  JIRAEPICS: 'Jira Epics',
  EDIT_EPIC_ICON_LABEL: 'Edit Epic',
  DELETE_EPIC_ICON_LABEL: 'Delete Epic',
  EDIT_STORY_ICON_LABEL: 'Edit Story',
  DELETE_STORY_ICON_LABEL: 'Delete Story',
  NO_EPICS_FOUND: 'No epics found',
  REFRESH_EPIC: 'Refresh epics from Jira',
  REQUIRED_ERROR_MESSAGE: 'This is a required field. Please enter a value',
  GENERATE_MORE_STORIES_FOR_EPIC: 'Storygenie Unleashed: More Stories',
  INVALID_VALUE: 'Invalid value',
  ERROR_MESSAGES: {
    INVALID_JIRA_EPICS: {
      HEADER: 'Uh Oh!',
      BODY: 'Looks like some of the epics are no longer available in Jira. You can reassign and try to publish to Jira again.'
    },
    JIRA_PUBLISH_BAD_REQUEST:
      'Not all of your items were successfully published to Jira. Please validate the remaining items before proceeding. If issues persist, contact storygenie support for assistance.',
    JIRA_PUBLISH_UNAUTHERISED:
      'You are not authorised to create issues in Jira for this project. Please contact your Jira admin to elevate your level of access before trying again.',
    INVALID_EPIC_OR_STORY:
      'Looks like some required fields are missing! Please revalidate all the issues. If the issue persists, contact storygenie support.',
    JIRA_PUBLISH_GENERIC_ERROR: {
      HEADER: 'Uh oh! Publishing issues failed',
      BODY: 'An unknown error occurred while publishing to Jira. Please try again soon. If issues persist, contact storygenie support for assistance.'
    },
    AI_GENERATION_FAIL: {
      HEADER: 'Uh oh! Issue generation failed',
      BODY: 'Looks like some error occurred while trying to generate issues for you. Please try again. If the issue persists, contact storygenie support.'
    },
    SMALL_MODEL_PROMPT_TOO_LARGE:
      'This prompt is large for the selected model and may time out. Please switch to a larger model and try again.',
    ENHANCE_AI_PROMPT_FAIL:
      'Something went wrong while generating enhanced prompt. Please try again!',
    ISSUE_TYPE_INVALID: {
      STORY:
        "Please check with your JIRA admin to ensure 'Story' issue type is enabled in your project.",
      EPIC: "Please check with your JIRA admin to ensure 'Epic' issue type is enabled in your project.",
      TASK:
        "Please check with your JIRA admin to ensure 'Task' issue type is enabled in your project.",
      EPIC_AND_STORY:
        "Please check with your JIRA admin to ensure 'Epic' and 'Story' issue types are enabled in your project.",
      EPIC_AND_TASK:
        "Please check with your JIRA admin to ensure 'Epic' and 'Task' issue types are enabled in your project.",
      STORY_AND_TASK:
        "Please check with your JIRA admin to ensure 'Story' and 'Task' issue types are enabled in your project."
    },
    RECENT_PROJECT_FETCH_FAIL: 'Failed to fetch your projects.',
    MAX_ISSUE_SIZE: `You have exceeded the threshold limit of ${ISSUE_PUBLISH_COUNT_THRESHOLD} epics/stories. Please remove epics/stories before publishing.`
  },
  NO_RESULT_SCREEN_MESSAGES: {
    HEADER: 'A clean slate, ready to cook!',
    BODY: 'Use the chat panel to begin mixing new work items.'
  },
  COPY: 'Copy',
  STORIES: 'stories',
  STORY: 'Story',
  CHAT_PANEL: {
    PROMPT_ENHANCER: 'Prompt Enhancer',
    PROMPT_ENHANCER_TOOLTIP: 'Enhance your prompt with AI suggestions',
    ATTACH_FILES: 'Attach Files',
    COMING_SOON: 'Coming soon',
    DISABLED: 'Disabled',
    MODEL_SELECTOR_LABEL: 'AI Model',
    GENERATION_TYPE_LABEL: 'Generate',
    VOLUME_LABEL: 'Volume',
    HIDE_PANEL: 'Hide panel',
    SMALL_MODEL_WARNING:
      'Large prompts can time out on smaller models. Consider switching to a larger model for better reliability.',
    SMALL_MODEL_AUTO_SWITCH:
      'Prompt too large for {from}. Switched to {to} for reliability.',
    GATEWAY_TIMEOUT_RETRY:
      'Gateway timeout on {from}. Retrying with {to} for reliability.',
    ISSUE_TYPE_WARNING: {
      SINGLE:
        '{types} work item type is not enabled in your project. Contact project admin to enable.',
      MULTIPLE:
        '{types} work item types are not enabled in your project. Contact project admin to enable.',
      CLOSE_LABEL: 'Close warning'
    },
    GENERATION_SUMMARY: {
      TITLE: 'Generation Complete',
      EPICS_LABEL: 'Epics',
      STORIES_LABEL: 'Stories',
      TYPE_LABEL: 'Type',
      MODEL_LABEL: 'Model',
      GENERATED_AT: 'Generated at',
      JUMP_TO_WORK_ITEMS: 'Jump to work items'
    },
    LOADING: {
      GENERATING: 'Generating your epics and stories...',
      ENHANCING: 'Enhancing your prompt...',
      PUBLISHING: 'Publishing to Jira...',
      LOADING_EPICS: 'Loading epics from Jira...'
    },
    EMPTY_STATE: {
      TITLE: 'Click to try a starter prompt',
      SUBTITLE: 'Click one to insert it into the chat box.',
      ENHANCER_HINT: 'Use Prompt Enhancer for max results.',
      SUGGESTED_PROMPTS: {
        CRM_TELCO:
          'Streamline telco sales & support with CRM',
        CRM_TELCO_EXPANDED:
          'A telco CRM system for sales and customer support, covering lead management, onboarding, and billing inquiries.',
        CX_GENAI_AGENCY:
          'Transform agency CX with GenAi',
        CX_GENAI_AGENCY_EXPANDED:
          'A government agency using GenAI to improve customer experience with chatbots, document processing, and multi-channel support.',
        MODERNISE_CLOUD:
          'Modernise legacy apps and migrate to cloud',
        MODERNISE_CLOUD_EXPANDED:
          'Modernising legacy applications and migrating to cloud, including microservices design and CI/CD pipelines.'
      }
    }
  }
};

export default Strings;
